import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BrandBlogPage from './BrandBlogPage';

export default function BlogPage() {
  return (
    <>
      <Navbar />
      <BrandBlogPage
        publisher="樂律文化"
        brandName="樂律文化"
        englishName="LELYRIC"
        tagline="閱讀，即是生活的旋律。"
      />
      <Footer />
    </>
  );
}

